export default __webpack_public_path__ + "static/media/ic-file-upload.d5a30c39.webp";